$(function () {
	$('.js-count-to').each(function () {
		var $this = $(this);
		var $number = $this.find('.js-count-to__number');
		var countTo = $number.attr('data-count');

		function animateText() {
			$number.text(1);

			$({ countNum: $number.text() }).animate(
			{
				countNum: countTo
			},
			{
				duration: 1000,
				easing:'swing',
				step: function() {
					$number.text(Math.floor(this.countNum));
				},
				complete: function() {
					$number.text(this.countNum);
				}
			});
		}

		$this.on('animationstart animationiteration', function(e) {
			animateText();
		});
	});
});



